import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import SegmentUtils                     from '../../utils/segment-utils';
import GroupedJSONResults               from './grouped-json-results/GroupedJSONResults';
import KeyPhrases                       from './KeyPhrases.js';
import TopicVector                      from './TopicVector.js';
import Industries                       from './Industries';
import Relationships                    from './relationships/Relationships';
import SentenceSalience                 from './SentenceSalience';

class DataControl extends Component {
    constructor(props){
        super(props);

        this.state = {

        }
    }

    render() {    
        return (
            <div className="datacontrol-wrapper">
                <GroupedJSONResults
                    entitiesData={this.props.entitiesData}
                    results={this.props.entities}
                    groups={SegmentUtils.groupByType(SegmentUtils.withMinConfidence(this.props.entities, this.props.minConfidence))}
                />
                <KeyPhrases phrases={this.props.keyPhrases} weights={this.props.keyPhraseWeights}/>
                <TopicVector vector={this.props.topicVector}/>
                <Industries industries={this.props.industries}/>
                {this.props.salience && this.props.salience.sentences &&
                    <SentenceSalience sentences={this.props.salience.sentences} />
                }
                {this.props.relationships &&
                    <Relationships 
                    entitiesData={this.props.entitiesData}
                    relationships={this.props.relationships} 
                    json={this.props.json} />
                }
            </div>
        );
    }
}

DataControl.propTypes = {
    entities: PropTypes.array.isRequired,
    minConfidence: PropTypes.number.isRequired,
    keyPhrases: PropTypes.array.isRequired,
    keyPhraseWeights: PropTypes.array.isRequired,
    topicVector: PropTypes.object.isRequired,
    industries: PropTypes.object,
    relationships: PropTypes.array,
    salience: PropTypes.object
};

export default DataControl;
